export default __webpack_public_path__ + "static/media/image19.257ae816.png";